import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useHealthMailSendPrescription = ({ onSuccess }) => {
  const queryClient = useQueryClient();

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useMutation({
    meta: { skipGlobalError: true },
    mutationFn: async ({
      prescriptionId,
      patientId,
      contactsIds,
      defaultContact,
    }) => {
      const axiosInstance = createAxiosInstance();

      const response = await axiosInstance.post(
        `${tenantVal}/patientprescription/send/prescription/${prescriptionId}/patient/${patientId}`,
        {
          healthMailContactId: contactsIds[0],
          defaultContact: defaultContact,
        }
      );
      return response.data;
    },
    onSuccess: () => {
      onSuccess?.();
      toast.success("Prescription sent successfully");
      queryClient.invalidateQueries();
    },
    onError: () => {
      toast.error("Failed to send prescription. Please try again.");
    },
  });
};

export default useHealthMailSendPrescription;
